"use client";

// Шелл портала разработчика: шапка без чатового сайдбара. Гейт здесь НЕ
// стоит — документация публична (её читают до подключения, и ИИ-агент
// разработчика не логинится вовсе). Консольные экраны гейтит свой layout
// группы (console).
import { DevShellHeader } from "@/components/dev/dev-shell-header";

export default function DevLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-m-background">
      <DevShellHeader />
      <main className="mx-auto w-full max-w-4xl px-6 py-8">{children}</main>
    </div>
  );
}
